import { apiPublicInstance } from '../services/API';

export function signInWithExternalSession(platformUUID: string, { externalSession }: { externalSession: string }) {
  return apiPublicInstance()
    .post(`/api/auth/${platformUUID}/externalSession`, {
      externalSession,
    })
    .then((res) => res.data);
}
